import { Component } from "@angular/core";
import * as $ from "jquery";
import swal from "sweetalert2";
import { NotificationsService } from "./services/notifications/notifications.service";
import { LanguageService } from "./services/i18n/language.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "app";

  constructor(
    private notificationsService: NotificationsService,
    private languageService: LanguageService
  ) {
    this.languageService.init();
    this.detectNetworkOffline();
  }

  ngOnInit(): void {
    this.notificationsService.initPush().then().catch();
  }

  detectNetworkOffline() {
    window.addEventListener("offline", () => {
      swal(
        "You are offline, please check your internet connection",
        "",
        "error"
      );
    });
  }

  detectNetworkOnline() {
    window.addEventListener("online", () => {
      console.log("network online now...");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts